"use client";

import { useReadContract } from "wagmi";
import ContractAddress from "@/contract/addresses";

/**
 * Just `calculator()`. Not the whole GATEWAY_ABI: wagmi resolves read types per
 * entry and the 148-entry V2 ABI trips TypeScript's "type instantiation is
 * excessively deep" limit -- the same wall `usePendingLegBv.ts` and
 * `usePlacementResolution.ts` hit. Present on V1 and V2 alike.
 */
const GATEWAY_CALCULATOR_ABI = [
  {
    type: "function",
    name: "calculator",
    stateMutability: "view",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
  },
] as const;

/**
 * The Calculator the gateway is pointed at right now.
 *
 * ALWAYS read this rather than `ContractAddress.CALCULATOR`. The DAO swaps the
 * Calculator often, so a build-time env var is stale from the moment a proposal
 * executes -- and the two are not even the same contract today: on prod
 * `NEXT_PUBLIC_CALCULATOR` is the STAKING calculator
 * (`0x24D3Bec4...`), while `gateway.calculator()` answers `0x0d4d4e62...`, the
 * MLM one that owns `BALANCE_POINTS`, `calcW` and `_settleWeek`.
 *
 * `undefined` while the read is in flight or if it fails. Callers must decide
 * what that means for them rather than substituting a guess.
 */
export const useGatewayCalculatorAddress = (): `0x${string}` | undefined => {
  const { data } = useReadContract({
    address: ContractAddress.GATEWAY,
    abi: GATEWAY_CALCULATOR_ABI,
    functionName: "calculator",
  });

  return data;
};
